import { ApiPath } from '@common/app/api-path';

import {
  type WithdrawPaymentRequestType,
  type WithdrawPaymentResponseType,
} from '@/common/types/payment';
import {
  type ActivateVipStatusBuyLinkResponseType,
  type ActivateVipStatusResponseType,
} from '@/common/types/query/user';

import { api } from '../base';

const paymentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    payment: builder.mutation<
      ActivateVipStatusResponseType | ActivateVipStatusBuyLinkResponseType,
      {
        amount: number;
        currency: 'XTR' | 'TON' | 'USDT';
        type: 'tgem' | 'dice';
      }
    >({
      query: (body) => ({
        url: ApiPath.PAYMENT + '/buy-Dice-Tgems',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['BOOST'],
    }),
    bindTonWallet: builder.mutation<void, { walletAddress: string }>({
      query: (body) => ({
        url: ApiPath.PAYMENT + '/bind-ton-wallet',
        method: 'POST',
        body,
      }),
    }),
    unBindTonWallet: builder.mutation<void, void>({
      query: () => ({
        url: ApiPath.PAYMENT + '/unbind-ton-wallet',
        method: 'POST',
      }),
    }),
    withdrawRequest: builder.mutation<
      WithdrawPaymentResponseType,
      WithdrawPaymentRequestType
    >({
      query: (body) => ({
        url: ApiPath.WITHDRAW_REQUEST,
        method: 'POST',
        body,
      }),
    }),
  }),
});

const {
  usePaymentMutation,
  useBindTonWalletMutation,
  useUnBindTonWalletMutation,
  useWithdrawRequestMutation,
} = paymentApi;

export {
  paymentApi,
  useBindTonWalletMutation,
  usePaymentMutation,
  useUnBindTonWalletMutation,
  useWithdrawRequestMutation,
};
